/**
 *  @class
 *  @function BackgroundVideo
 */
if (!customElements.get('background-video')) {
	class BackgroundVideo extends HTMLElement {
		constructor() {
			super();

			this.tl = false;
			this.splittext = false;
		}
			connectedCallback() {
				let _this = this;

				// Video Support.
				let video_container = this.querySelector('.background-video__iframe');
				if (video_container) {
					const hostedVideo = video_container.querySelector('[data-deferred-video]');
					if (hostedVideo) {
						hostedVideo.addEventListener('playing', () => {
							video_container.classList.add('is-playing');
						}, { once: true });
						this.scheduleHostedVideo(hostedVideo);
					}
					if (video_container.querySelector('iframe')) {
						video_container.querySelector('iframe').onload = function () {
							_this.videoPlay(video_container);
					};
					}
				}
			}
			scheduleHostedVideo(video) {
				const intentEvents = ['pointerdown', 'keydown', 'touchstart', 'scroll'];
				const removeIntentListeners = () => {
					intentEvents.forEach((eventName) => {
						window.removeEventListener(eventName, loadVideo);
					});
				};
				const loadVideo = () => {
					if (
						video.dataset.loaded ||
						navigator.connection?.saveData ||
						window.matchMedia('(prefers-reduced-motion: reduce)').matches
					) return;
					removeIntentListeners();
					video.dataset.loaded = 'true';
					video.querySelectorAll('source[data-src]').forEach((source) => {
						source.src = source.dataset.src;
						if (source.dataset.media) source.media = source.dataset.media;
						source.removeAttribute('data-src');
					});
					video.load();
					const playPromise = video.play();
					if (playPromise) playPromise.catch(() => {});
				};
				intentEvents.forEach((eventName) => {
					window.addEventListener(eventName, loadVideo, { once: true, passive: true });
				});
			}
		videoPlay(video_container) {
			setTimeout(() => {
				if (video_container.dataset.provider === 'youtube') {
					video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({ event: "command", func: "playVideo", args: "" }), "*");
				} else if (video_container.dataset.provider === 'vimeo') {
					video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({ method: "play" }), "*");
				}
			}, 10);
		}
	}
	customElements.define('background-video', BackgroundVideo);
}
